import _merge from 'lodash/merge';
import { HD, FULL_HD } from '@bedrock-rdk/constants';
import { PRIMARY, makeThemeColor, QUATERNARY, TERTIARY } from '@tornado-rdk/theme';
import { makeDefaultStylingContext } from '../utils/style';
import { SCALE_FOCUSED } from '../utils/focus';
import { middle } from '../utils/sizes';

export const defaultContext = makeDefaultStylingContext();

export const SIZE = {
  [HD]: 56,
  [FULL_HD]: 64,
};

export const BORDER_RADIUS = {
  [HD]: SIZE[HD] / 2,
  [FULL_HD]: SIZE[FULL_HD] / 2,
};

export const colors = {
  background: makeThemeColor(QUATERNARY, 0.3),
  icon: makeThemeColor(PRIMARY),
  backgroundFocused: makeThemeColor(QUATERNARY),
  iconFocused: makeThemeColor(TERTIARY),
  backgroundDisabled: makeThemeColor(QUATERNARY, 0.1),
  iconDisabled: makeThemeColor(PRIMARY, 0.1),
};

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize, colorMode } = context;
  const size = SIZE[screenSize];

  return _merge({
    w: size,
    h: size,
    Background: {
      w: size,
      h: size,
      color: colors.background[colorMode],
      shader: {
        radius: BORDER_RADIUS[screenSize],
      },
    },
    Icon: {
      color: colors.icon[colorMode],
      mount: 0.5,
      x: middle,
      y: middle,
    },
  });
};

export const getFocusedStyle = ({ colorMode }) => ({
  Background: {
    smooth: {
      scale: SCALE_FOCUSED,
      color: colors.backgroundFocused[colorMode],
    },
  },
  Icon: {
    smooth: {
      scale: SCALE_FOCUSED,
      color: colors.iconFocused[colorMode],
    },
  },
});

export const getUnFocusedStyle = ({ colorMode }) => ({
  Background: {
    smooth: {
      scale: 1.0,
      color: colors.background[colorMode],
    },
  },
  Icon: {
    smooth: {
      scale: 1.0,
      color: colors.icon[colorMode],
    },
  },
});

export const getDisabledStyle = ({ colorMode }) => ({
  Background: {
    smooth: {
      scale: 1.0,
      color: colors.backgroundDisabled[colorMode],
    },
  },
  Icon: {
    smooth: {
      scale: 1.0,
      color: colors.iconDisabled[colorMode],
    },
  },
});
